const keyName = 'programBuilderSelectedTopics';

export function clearStorage() {
  localStorage.setItem(keyName, null);
  localStorage.removeItem(keyName);
}

export function saveItems(ids) {
  localStorage.setItem(keyName, JSON.stringify(ids));
}

export function getItems() {
  const data = localStorage.getItem(keyName);
  if (data === null) {
    return null;
  }
  return JSON.parse(data);
}
